// The overall voter count the backend adds to every search (api/routes/search_api.py). It is
// implicit, so the search bar never shows it as a pill.
export const TOPLINE_DISPLAY = "Registered Voters";

const DEFAULT_TOPLINE_AGGREGATION = "count";

// A count topline is the implicit one; a percent topline is something the user toggled to, so it
// stays in the query text and keeps the backend from adding its own.
export const isImplicitTopline = (metric, aggregation = metric.aggregation) =>
  metric.metric === "topline" && (aggregation ?? DEFAULT_TOPLINE_AGGREGATION) === DEFAULT_TOPLINE_AGGREGATION;

// Saved searches from before the pill was hidden still carry it in their segments.
export function withoutToplinePill(segments) {
  const isToplinePill = (piece) =>
    typeof piece === "object" && piece?.pill?.toLowerCase() === TOPLINE_DISPLAY.toLowerCase();
  const [first, ...rest] = (Array.isArray(segments) ? segments : []).filter(
    (piece) => !isToplinePill(piece)
  );
  const leading = typeof first === "string" ? first.trimStart() : first;
  return leading === undefined || leading === "" ? rest : [leading, ...rest];
}
